import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';

import { coolGrey, grape, squidInk } from 'lib/css/colors';

function EmptyState({
  icon = faBoxOpen,
  title = 'No results found',
  description = 'Try adjusting your search or filter criteria.',
  iconColor = grape,
  iconBgColor = `${grape}15`,
  children,
}) {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.iconContainer)} style={{ backgroundColor: iconBgColor }}>
        <FontAwesomeIcon icon={icon} className={css(styles.icon)} style={{ color: iconColor }} />
      </div>
      <h3 className={css(styles.title)}>{title}</h3>
      {description && <p className={css(styles.description)}>{description}</p>}
      {children && <div className={css(styles.actions)}>{children}</div>}
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    textAlign: 'center',
  },
  iconContainer: {
    width: 100,
    height: 100,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
  },
  icon: {
    fontSize: 44,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: squidInk,
    margin: 0,
    marginBottom: 12,
  },
  description: {
    fontSize: 15,
    color: coolGrey,
    margin: 0,
    maxWidth: 360,
    lineHeight: 1.5,
  },
  actions: {
    marginTop: 24,
  },
});

EmptyState.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  iconColor: PropTypes.string,
  iconBgColor: PropTypes.string,
  children: PropTypes.node,
};

export default EmptyState;
